import React from 'react';
import { Award } from 'lucide-react';
import { clients } from '../data/mockData';

const Clients = () => {
  return (
    <section id="clients" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-2 mb-4">
            <Award className="text-amber-600" size={16} />
            <span className="text-amber-600 font-medium text-sm">Our Clients</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Trusted by Leading Organizations
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Partnering with government ministries, international agencies, and major corporations across Nigeria
          </p>
        </div>

        {/* Trust Badge */}
        <div className="bg-gradient-to-r from-blue-900 to-slate-900 rounded-3xl p-8 lg:p-12 mb-12 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-center space-x-4 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_smc-nigeria-pro/artifacts/fjo8g9vi_Coat_of_arms_of_Nigeria.svg.png" 
                alt="Nigerian Coat of Arms" 
                className="w-24 h-24 object-contain"
              />
              <h3 className="text-2xl lg:text-3xl font-bold text-white">
                Endorsed by The Presidency
              </h3>
            </div>
            <p className="text-gray-300 text-lg">
              Our work has received official endorsement from various government arms including The Presidency, 
              National Sports Commission, and National Orientation Agency - a testament to our commitment to excellence.
            </p>
          </div>
        </div>

        {/* Clients Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-slate-50 to-blue-50 border-2 border-gray-200 hover:border-amber-400 rounded-xl p-6 transition-all duration-300 hover:shadow-lg transform hover:scale-105"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <Award className="text-slate-900" size={24} />
                </div>
                <div className="flex-1">
                  <h4 className="font-bold text-slate-900 leading-tight group-hover:text-blue-900 transition-colors">
                    {client}
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Sectors Served */}
        <div className="mt-16 bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl p-8 lg:p-12">
          <h3 className="text-3xl font-bold text-slate-900 mb-8 text-center">
            Sectors We Serve
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              "Health", "Security & Intelligence", "Technology", "Oil & Gas",
              "Foreign Affairs", "Agriculture", "Development", "Commerce",
              "Defence & Army", "Education", "Finance", "National Planning",
              "Banking & Insurance", "Power", "Solid Minerals", "Police Affairs"
            ].map((sector, index) => (
              <span
                key={index}
                className="bg-white border-2 border-gray-200 hover:border-amber-400 text-gray-700 hover:text-slate-900 px-5 py-2 rounded-full font-medium transition-all duration-300 transform hover:scale-105"
              >
                {sector}
              </span>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <h3 className="text-3xl font-bold text-slate-900 mb-4">
            Join Our Growing List of Satisfied Clients
          </h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Experience the SMC difference - where expertise meets innovation for transformative results.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-amber-400 to-yellow-600 text-slate-900 hover:from-amber-500 hover:to-yellow-700 font-semibold px-10 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 text-lg"
          >
            Partner With Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default Clients;
